import { CATS, colorHex } from '../data/catalog.js';
import { fmt } from '../lib/money.js';
import { useStore } from '../lib/store.jsx';
import { useI18n } from '../lib/i18n.jsx';
import ProductViz from './ProductViz.jsx';

export default function ProductCard({ product: p, nav }) {
  const { addToCart, setDrawerOpen } = useStore();
  const { t } = useI18n();
  const sold = p.tag === 'sold';
  const hasChoices = (p.colors && p.colors.length > 1) || (p.options && p.options.length);
  const open = () => nav(`/p/${p.id || p.sku}`);

  const quickAdd = (e) => {
    e.stopPropagation();
    if (hasChoices) { open(); return; }
    const ok = addToCart(p.id, p.colors && p.colors.length === 1 ? p.colors[0] : null, null);
    if (ok) setDrawerOpen(true);
  };

  return (
    <div className="card">
      <div className="imgw" onClick={open}>
        {sold && <span className="tag sold">Sold out</span>}
        {p.tag === 'new' && <span className="tag new">New</span>}
        <ProductViz product={p} />
        {!sold && (
          <div className="quickadd">
            <button className="btn full sm" onClick={quickAdd}>
              {hasChoices ? t('card.choose') : t('card.add')}
            </button>
          </div>
        )}
      </div>
      <div className="info">
        <div className="sku">{CATS[p.cat]?.t}</div>
        <div className="nm" onClick={open}>{p.name}</div>
        <div className="row">
          <div className="pr">{p.price !== null ? fmt(p.price) : <span className="ask">{t('pdp.ask')}</span>}</div>
          {p.colors && p.colors.length > 1 && (
            <div className="swatches">
              {p.colors.slice(0, 5).map((c) => (
                <span key={c} className="sw" title={c} style={{ background: colorHex(c) }} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
